const $inject = ['$location', 'dataService'];

const lbaSearchByCtrl = function ($location, dataService) {
  const vm = this;
  vm.search = search;
  vm.loadResult = loadResult;
  vm.searchTarget = vm.settings.targetChoices[0];
  vm.searchResults = [];
  vm.searchText = '';
  vm.searching = false;

  function search(searchString) {
    vm.searching = true;
    dataService.search(vm.settings.endpoint, searchString, vm.searchTarget).then(data => {
      vm.searching = false;
      vm.searchResults = data;
    });
  }

  function loadResult(id) {
    $location.path($location.$$path + '/' + id);
  }

};

lbaSearchByCtrl.$inject = $inject;

export default lbaSearchByCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaSearchBy/lbaSearchByCtrl.js